import { autoserializeAs } from 'cerialize';

import { Document } from './document';
import { Driver } from './driver';

export class DocumentReviewItem {
    @autoserializeAs(Document)
    documents: Array<Document>;

    @autoserializeAs(Driver)
    driver: Driver;
}
